import React from 'react';
import cn from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  TwitterIcon,
  FacebookIcon,
  LinkedinIcon,
} from 'react-share';

import ShareIcon from './assets/share.svg';

const styles = theme => ({
  root: {},
  container: {
    display: 'flex',
    '&:hover $icons': { visibility: 'visible', opacity: 1 },
    '&:hover $mainIcon': { transform: 'rotate(180deg)' },
  },
  button: { outline: 'none', cursor: 'pointer' },
  icon: { width: 19.3, height: 20.5 },
  icons: {
    display: 'flex',
    visibility: 'hidden',
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  mainIcon: {
    transform: 'rotate(0deg)',
    transitionProperty: 'transform',
    transitionDuration: '0.2s',
  },
});

const Share = ({ classes, className, url, title }) => {
  const twitterParams = {
    url,
    via: process.env.GATSBY_TWITTER_ACCOUNT_NAME,
    title,
  };

  const facebookParams = {
    url,
    quote: title,
  };

  const linkedInParams = {
    url,
    windowWidth: 750,
    windowHeight: 600,
  };

  return (
    <div className={cn(classes.root, { [className]: !!className })}>
      <div className={classes.container}>
        <div className={classes.icons}>
          <FacebookShareButton {...facebookParams} className={classes.button}>
            <FacebookIcon size={25} round className={classes.icon} />
          </FacebookShareButton>
          <TwitterShareButton {...twitterParams} className={classes.button}>
            <TwitterIcon size={25} round className={classes.icon} />
          </TwitterShareButton>
          <LinkedinShareButton {...linkedInParams} className={classes.button}>
            <LinkedinIcon size={25} round className={classes.icon} />
          </LinkedinShareButton>
        </div>
        <img
          src={ShareIcon}
          alt="share-icon"
          className={cn(classes.icon, classes.mainIcon)}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(Share);
